import React, { useEffect, useState } from 'react';
import '../App.css';
import { Alert } from 'react-bootstrap';
import Axios from 'axios';
import Bodyheaderloged from './bodyheaderloged';
import Calendar from './calendar'

function Bodycompracafeteria(props) {
    const [productos, setProductos] = useState([]);          // Productos disponibles
    const [productosCarro, setProductosCarro] = useState([]); // Productos en el carrito
    const [productosCompra, setProductosCompra] = useState([]); // Productos comprados (carrito temporal)
    const [orden, setOrden] = useState([]);                   // Productos en la orden final
    const [comandaEnviada, setComandaEnviada] = useState(false); // Estado para mostrar el popup de éxito
    const [comandaNoEnviada, setComandaNoEnviada] = useState(false);
    const [error, setError] = useState('');
    const [deliveryDate, setDeliveryDate] = useState('');
    const [deliveryHour, setDeliveryHour] = useState('0');
    const [deliveryMinute, setDeliveryMinute] = useState('0');
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('');
    const [categorias, setCategorias] = useState([]);
    const [casinos, setCasinos] = useState([]);
    const [todosLosProductos, setTodosLosProductos] = useState([]); 
    const [isScheduled, setIsScheduled] = useState(false);
    const [casinoSeleccionado, setCasinoSeleccionado] = useState("");

    const handleChange = (event) => {
        setCasinoSeleccionado(event.target.value);
    };
    // Obtener la fecha actual en formato YYYY-MM-DD
    const currentDate = new Date().toISOString().split('T')[0]; // '2025-04-06'

    const GetCategorias = () => {
        Axios.get(process.env.REACT_APP_URLGETCATEGORIAS)
            .then((response) => {
                setCategorias(response.data.categoria);  // 🔹 Guardamos las categorías obtenidas en el estado
            })
            .catch(error => {
                console.error("Error al obtener categorías:", error);
            });
    };

    const getCasino = () =>{
        Axios.get(process.env.REACT_APP_URLGETCASINONOTCICLOINICIAL)
        .then((response) => {
            setCasinos(response.data.casinos);  // 🔹 Guardamos las categorías obtenidas en el estado
        })
        .catch(error => {
            console.error("Error al obtener categorías:", error);
        });
    }

    // Filtrar productos cuando cambia la categoría seleccionada
    useEffect(() => {
        if (categoriaSeleccionada === "") {
            setProductos(todosLosProductos); // Si no hay categoría, mostrar todos los productos
        } else {
            const productosFiltrados = todosLosProductos.filter(
                (producto) => producto.categoria_producto_cafeteria_id === parseInt(categoriaSeleccionada)
            );
            setProductos(productosFiltrados);
        }
    }, [categoriaSeleccionada, todosLosProductos]);     

    // Control de los alerts para que desaparezcan después de 5 segundos
    useEffect(() => {
        if (comandaEnviada) {
            const timer = setTimeout(() => {
                setComandaEnviada(false);  // Ocultar alerta de éxito después de 5 segundos
            }, 5000);
            return () => clearTimeout(timer); // Limpiar el timer si el componente se desmonta o cambia
        }
    }, [comandaEnviada]);

    useEffect(() => {
        if (comandaNoEnviada) {
            const timer = setTimeout(() => {
                setComandaNoEnviada(false);  // Ocultar alerta de error después de 5 segundos
            }, 5000);
            return () => clearTimeout(timer); // Limpiar el timer si el componente se desmonta o cambia
        }
    }, [comandaNoEnviada]);

    useEffect(() => {
        GetCategorias();
        getCasino();
    }, []);

    ///const productosList = productos.map((item, i) =>
    ///    <ul className="space-y-4" key={i}>
    ///        <li className="flex justify-between items-center">
    ///            <div className="flex items-center space-x-4">
    ///                <img src={item.imagen} alt="Producto 1" className="w-12 h-12 object-cover rounded-md" />
    ///                <div>
    ///                    <h3 className="text-lg font-medium">{item.nombre}</h3>
    ///                    <p className="text-gray-500">$ {item.precio}</p>
    ///                </div>
    ///            </div>
    ///            <button 
    ///                className={`bg-blue-500 text-white px-4 py-2 rounded-lg ${item.existencia <= 0 ? 'bg-gray-400 cursor-not-allowed' : ''}`} 
    ///                onClick={() => addProduct(item)} 
    ///                disabled={item.existencia <= 0}
    ///            >       Agregar</button>
    ///        </li>
    ///        {/* Mostrar mensaje de 'Producto sin stock' si la existencia es 0 o menor */}
    ///        {item.existencia <= 0 && (
    ///            <p className="text-red-500 text-sm mt-2">Producto sin stock</p>
    ///        )}
    ///    </ul>
    ///); 

    const productosList = (
    <ul className="space-y-3">
        {productos.map((item) => {
        const agotado = item.existencia <= 0;

        return (
            <li
            key={item.id}
            className="flex items-stretch justify-between gap-4 p-3 rounded-lg border border-gray-200 bg-white hover:shadow-sm transition"
            >
            {/* IZQUIERDA: info */}
            <div className="flex flex-col flex-1 min-w-0">
                {/* Nombre (máx 2 líneas, ocupa todo el ancho disponible) */}
                <h3
                className="text-sm md:text-base font-semibold text-gray-900"
                style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                }}
                title={item.nombre}
                >
                {item.nombre}
                </h3>

                {/* Precio + Stock en la misma línea */}
                <div className="mt-1 flex items-center gap-3">
                <p className="text-sm font-medium text-gray-800">$ {item.precio}</p>
                {agotado ? (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-red-100 text-red-700">
                    Producto sin stock
                    </span>
                ) : (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-700">
                    Stock: {item.existencia}
                    </span>
                )}
                </div>

                {/* Botón */}
                <div className="mt-2">
                <button
                    className={`px-3 py-1.5 rounded-lg text-sm font-medium transition
                    ${agotado ? 'bg-gray-300 text-gray-600 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 text-white'}`}
                    onClick={() => !agotado && addProduct(item)}
                    disabled={agotado}
                >
                    Agregar
                </button>
                </div>
            </div>

            {/* DERECHA: imagen (mismo tamaño de antes) */}
            <div className="shrink-0 w-28 h-20 md:w-32 md:h-24 rounded-md overflow-hidden bg-gray-100 shadow-sm self-center">
                <img
                src={item.imagen}
                alt={item.nombre}
                loading="lazy"
                className="w-full h-full object-cover"
                />
            </div>
            </li>
        );
        })}
    </ul>
    );


    const productosCarroList = productosCarro.map((item, i) =>
        <ul className="space-y-4" key={i}>
            <li className="flex justify-between items-center border-b pb-4">
                <div className="flex items-center space-x-4">
                    <img src={item.imagen} alt="Producto 1" className="w-12 h-12 object-cover rounded-md" />
                    <div className="flex flex-col">
                        <h4 className="text-lg font-medium text-ellipsis overflow-hidden w-32">{item.nombre}</h4>
                        <p className="text-gray-500">$ {item.precio}</p>
                    </div>
                </div>

                <div className="flex items-center space-x-2">
                    <button
                        className="bg-gray-200 text-gray-700 px-2 py-1 rounded-lg"
                        onClick={() => actualizarCantidad(item.id, "-")}
                    >
                        -
                    </button>
                    <span className="text-gray-800">{item.cantidad}</span>
                    <button
                        className={`bg-gray-200 text-gray-700 px-2 py-1 rounded-lg ${item.cantidad >= item.existencia || item.existencia <= 0 ? 'bg-gray-400 cursor-not-allowed' : ''}`}
                        onClick={() => actualizarCantidad(item.id, "+")}
                        disabled={item.cantidad >= item.existencia || item.existencia <= 0}
                    >
                        +
                    </button>
                </div>

                <p className="text-gray-800">${(item.precio * item.cantidad).toFixed(0)}</p>

                <button className="text-red-500" onClick={() => eliminarProducto(item.id)}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </button>
            </li>
        </ul>
    );

    const GetProductos = () => {
        let casino_id = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '');
        Axios.get(process.env.REACT_APP_URLGETPRODUCTOS, {
            params: {
                casino_id: casino_id
            },
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setProductos(response.data.productos);
            setTodosLosProductos(response.data.productos); 
        }).catch(error => {
            console.error(error);
        });
    };



    const addProduct = (item) => {
        if (item.existencia > 0) {
            let existe = false;
            let items = productosCarro.map((prod) => {
                if (prod.id === item.id) {
                    existe = true;
                    return { ...prod, cantidad: prod.cantidad + 1 };
                }
                return prod;
            });
    
            if (!existe) {
                items.push({ ...item, cantidad: 1 });
            }
    
            // Actualizar el carrito
            setProductosCarro(items);
    
            // Actualizar la existencia del producto en el estado de productos
            const updatedProductos = productos.map((prod) => {
                if (prod.id === item.id && prod.existencia > 0) {
                    return { ...prod, existencia: prod.existencia - 1 };
                }
                return prod;
            });
    
            // Actualizar la lista de productos disponibles con la existencia modificada
            setProductos(updatedProductos);
        }
    };
    
    const actualizarCantidad = (id, tipo) => {
        const items = productosCarro.map(item => {
            if (item.id === id) {
                let nuevaCantidad = tipo === "+" ? item.cantidad + 1 : item.cantidad - 1;
                nuevaCantidad = Math.max(nuevaCantidad, 1);  // Evitar cantidad negativa
    
                // Actualizar la existencia en el carrito (restar o sumar según tipo)
                const updatedProductos = productos.map((prod) => {
                    if (prod.id === item.id) {
                        let newExistencia = prod.existencia + (tipo === "+" ? -1 : 1);  // Restar o sumar dependiendo de la acción
                        return { ...prod, existencia: Math.max(newExistencia, 0) };  // Asegurar que no sea negativo
                    }
                    return prod;
                });
    
                setProductos(updatedProductos);  // Actualizar estado de productos
    
                return { ...item, cantidad: nuevaCantidad };  // Retornar el item con la nueva cantidad
            }
            return item;
        });
    
        setProductosCarro(items);
    };

    const eliminarProducto = (id) => {
        const items = productosCarro.filter(item => item.id !== id);
        setProductosCarro(items);
    };

    const crearOrden = () => {
        // Copiar los productos del carrito a la orden
        setOrden([...productosCarro]);
        // Vaciar el carrito
        setProductosCarro([]);

        // Enviar la solicitud al backend para bloquear los productos
        //const productosParaBloquear = productosCarro.map(item => ({
            //producto_id: item.id,
            //cantidad: item.cantidad
        //}));

        // Llamada a la API para bloquear los productos seleccionados
        //Axios.post(`${process.env.REACT_APP_URLPOSTPRODUCTOSBLOQUEASTOCK}`, { productos: productosParaBloquear })
        //.then(response => {
            // Si el bloqueo fue exitoso, proceder con la creación de la orden
            //if (response.status === 200) {
                //enviarComanda();  // Llamar a la función para procesar la comanda
            //} else {
                // Si no se pudo bloquear, mostrar un mensaje de error
                //alert("Hubo un problema al bloquear el stock, intenta de nuevo.");
            //}
        //})
        //.catch(error => {
            //console.error("Error al bloquear stock:", error);
            //alert("Error al bloquear el stock, intenta de nuevo.");
        //});        

    };

    // Calcular el total de la orden
    const calcularTotal = (productos) => {
        return productos.reduce((total, item) => total + (item.precio * item.cantidad), 0).toFixed(0);
    };

    const cancelarOrden = () => {
        // Limpiar el estado de la orden, el carrito y los productos seleccionados
        setOrden([]);
        setProductosCarro([]);
        setProductosCompra([]);
        GetProductos();
        setIsScheduled(false)
    };

    // Función para realizar la llamada a la API /productos/comanda
    const enviarComanda = () => {
        const fechaActual = new Date();
        let fecha;
        let hora;
        let fecha_creacion;
        let hora_creacion;

        if(isScheduled){
            fecha = deliveryDate.split('T')[0];
            hora = deliveryHour.split(' ')[0] + ":" + deliveryMinute + ":00";
            fecha_creacion = fechaActual.toISOString().split('T')[0];
            hora_creacion = fechaActual.toTimeString().split(' ')[0];
            
            console.log("Hora Seleccionada: " + hora)
            console.log("Fecha: " + deliveryDate);
            console.log("Hora: " + deliveryHour);
            console.log("Fecha: " + fecha);
            console.log("Hora: " + hora);
        }else{
            fecha = ''; 
            hora = '';
            fecha_creacion = fechaActual.toISOString().split('T')[0];
            hora_creacion = fechaActual.toTimeString().split(' ')[0];
        }
        
    
        const casino_id = casinoSeleccionado;//window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '');
        const user_id_1 = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '');
        const user_id = user_id_1.replace('"', '');
    
        // Modificar comandaDetalle para enviar el id y el total de la fila
        const comandaDetalle = orden.map(item => ({
            producto_id: item.id,
            cantidad: item.cantidad
        }));
    
        const comandaData = {
            fecha: fecha,
            hora: hora,
            casino_id: casino_id,
            user_id: user_id,
            comanda_estado: 1,
            comanda_detalle: comandaDetalle,
            fecha_creacion: fecha_creacion,
            hora_creacion: hora_creacion
        };


   
        // Realizar la solicitud POST a la API /productos/comanda
        Axios.post(process.env.REACT_APP_URLPOSTPRODUCTOSCOMANDA, comandaData, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            console.log('Comanda enviada correctamente:', response);
            // Enviar los datos a la API /productos/compra si la respuesta es positiva
            if (response.status === 200) {

                const compraDetalle = orden.map(item => ({
                    producto_id: item.id,
                    precio: item.precio,
                    cantidad: item.cantidad,
                    total_fila: item.precio * item.cantidad,
                }));
                // Ahora enviar los datos de la compra
                const compraData = {
                    fecha: `${fecha_creacion} ${hora_creacion}`,
                    casino_id: casino_id,
                    user_id: user_id,
                    estado_comanda: 2,
                    comanda_id: response.data.comanda_id,
                    compra_detalle: compraDetalle // Los productos con el id y el total de la fila
                };
    
                // Realizar la solicitud POST a la API /productos/compra
                Axios.post(process.env.REACT_APP_URLPOSTPRODUCTOSCOMPRA, compraData, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(compraResponse => {
                    console.log('Compra realizada correctamente:', compraResponse);
                    // Aquí puedes agregar cualquier lógica adicional si la compra es exitosa
                    console.log('Orden enviada correctamente:', response);
                    // Mostrar el popup de éxito
                    setComandaEnviada(true);
                    // Limpiar el estado después de enviar la orden
                    cancelarOrden();
                })
                .catch(compraError => {
                    console.error('Error al realizar la compra:', compraError);
                    console.error('Error al realizar la compra:', compraError.response.data.error);
                    const errorMessage = compraError.response?.data?.error     
                    setError(errorMessage)
                    setComandaNoEnviada(true);
                });
            }
        })
        .catch(error => {
            console.error('Error al enviar la comanda:', error);
            const errorMessage = error.response?.data?.error 
            setError(errorMessage)
            setComandaNoEnviada(true);
        });
    };

    useEffect(() => {
        GetProductos();
    }, []);

    return (
        <div className='w-full'>
            <div className='flex justify-start w-full'>
                <Bodyheaderloged mailloginP={props.mailloginP} apptokenP={props.apptokenP} setStateMailP={props.setStateMailP} />
            </div>
            <div className="max-w-screen-xl mx-auto p-4">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                    <div className="lg:col-span-2 space-y-4">
                        {/* Contenedor flex para el selector y la lista */}
                        <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0">
                            {/* Selector de Categoría (Arriba en móviles, izquierda en pantallas grandes) */}
                            <div className="lg:w-1/4">
                            <label className="text-lg font-semibold text-gray-900">Categoría de Productos</label>
                            <select
                                className="mt-2 w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                                value={categoriaSeleccionada}
                                onChange={(e) => setCategoriaSeleccionada(e.target.value)}
                            >
                                <option value="">Todas las categorías</option>
                                {categorias.map((categoria) => (
                                <option key={categoria.id} value={categoria.id}>
                                    {categoria.nombre}
                                </option>
                                ))}
                            </select>
                            </div>

                            {/* Lista de Productos */}
                            <div className="lg:w-3/4 bg-white rounded-lg shadow-md p-4 max-h-[350px] overflow-y-scroll">
                            {productosList}
                            </div>
                        </div>
                    </div>
                    <div className="lg:col-span-1 space-y-4">
                        <h2 className="text-2xl font-semibold text-gray-900">Carrito de Compras</h2>

                        {/*<div className="lg:w-3/4 bg-white rounded-lg shadow-md p-4 max-h-[70vh] overflow-y-auto">
                        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
                            {productosList}
                        </div>
                        </div>*/}                        
                        
                        <div className="bg-white rounded-lg shadow-md p-4 max-h-[350px] overflow-y-scroll">
                            {productosCarroList}
                        </div>

                        {/* Botón Crear Orden */}
                        <button 
                            className="mt-4 bg-blue-500 text-white px-6 py-3 rounded-lg w-full"
                            onClick={crearOrden}
                        >
                            Crear Orden
                        </button>
                       
                    </div>
                </div>

                {/* Detalle de productos seleccionados y total */}
                <div className="mt-8 bg-white rounded-lg shadow-md p-4">
                    <h2 className="text-2xl font-semibold text-gray-900">Resumen de Compra</h2>
                    <table className="min-w-full mt-4">
                        <thead>
                            <tr className="border-b">
                                <th className="py-2 text-left text-sm font-medium text-gray-600">Producto</th>
                                <th className="py-2 text-left text-sm font-medium text-gray-600">Cantidad</th>
                                <th className="py-2 text-left text-sm font-medium text-gray-600">Precio</th>
                                <th className="py-2 text-left text-sm font-medium text-gray-600">Subtotal</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orden.map((item, i) => (
                                <tr className="border-b" key={i}>
                                    <td className="py-2">{item.nombre}</td>
                                    <td className="py-2">{item.cantidad}</td>
                                    <td className="py-2">${item.precio}</td>
                                    <td className="py-2">${(item.precio * item.cantidad).toFixed(0)}</td>
                                </tr>
                            ))}
                            <tr>
                                <td className="py-2 text-right font-semibold" colSpan="3">Total</td>
                                <td className="py-2 font-semibold">${calcularTotal(orden)}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="mt-6 p-4 bg-gray-100 rounded-lg shadow-md">
                        {/* Checkbox para activar/desactivar la sección */}
                        <div className="flex items-center mb-4">
                            <input
                                type="checkbox"
                                id="scheduleDelivery"
                                className="mr-2 w-5 h-5"
                                checked={isScheduled}
                                onChange={() => setIsScheduled(!isScheduled)}
                            />
                            <label htmlFor="scheduleDelivery" className="text-lg font-semibold text-gray-800">
                                📦 Programar entrega de orden
                            </label>
                        </div>

                        {/* Contenido solo si el checkbox está activado */}
                        {isScheduled && (
                            <div>
                                <h3 className="text-xl font-semibold text-gray-800 mb-4">
                                    📦 Programación de la Entrega de su Orden
                                </h3>

                                <div className="flex space-x-4 items-center">
                                    {/* Selector de Fecha */}
                                    <div className="flex flex-col">
                                        <label className="text-gray-700 font-semibold mb-1">Fecha de Entrega:</label>
                                        <input
                                            type="date"
                                            min={currentDate}
                                            className="p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                                            value={deliveryDate}
                                            onChange={(e) => setDeliveryDate(e.target.value)}
                                        />
                                    </div>

                                    {/* Selector de Hora */}
                                    <div className="flex flex-col">
                                        <label className="text-gray-700 font-semibold mb-1">Hora de Entrega:</label>
                                        <div className="flex space-x-2">
                                            <select
                                                className="p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                                                value={deliveryHour}
                                                onChange={(e) => setDeliveryHour(e.target.value)}
                                            >
                                                {[...Array(9).keys()].map((hour) => (
                                                    <option key={hour} value={hour + 8}>
                                                        {(hour + 8).toString().padStart(2, '0')}
                                                    </option>
                                                ))}
                                            </select>
                                            <span className="self-center text-lg">:</span>
                                            <select
                                                className="p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                                                value={deliveryMinute}
                                                onChange={(e) => setDeliveryMinute(e.target.value)}
                                            >
                                                {[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55].map((minute) => (
                                                    <option key={minute} value={minute}>
                                                        {minute.toString().padStart(2, '0')}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Selector de Casino */}
                                    <div className="flex flex-col">
                                        <label className="text-gray-700 font-semibold mb-1">Casino de entrega:</label>
                                        <div className="flex space-x-2">
                                            <select
                                                className="p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                                                value={casinoSeleccionado} onChange={handleChange}
                                            >
                                                <option value="">Seleccione un casino</option> {/* Opción por defecto */}
                                                   {casinos.map(casino => (
                                                        <option key={casino.id} value={casino.id}>
                                                        {casino.nombre}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="flex space-x-4 mt-4">
                        <button className="bg-green-500 text-white px-6 py-3 rounded-lg w-full" onClick={enviarComanda}>Pagar</button>
                        <button
                            className="bg-red-500 text-white px-6 py-3 rounded-lg w-full"
                            onClick={cancelarOrden}
                        >
                            Cancelar Orden
                        </button>
                    </div>
                </div>
            </div>

            {/* Popup de confirmación */}
            {comandaEnviada && (
                <Alert variant="success" onClose={() => setComandaEnviada(false)} dismissible
                style={{
                    position: 'fixed', top: '10px', left: '50%', transform: 'translateX(-50%)', zIndex: 9999, width: 'auto'
                }}>
                    <Alert.Heading>¡Orden Enviada!</Alert.Heading>
                    <p>La orden ha sido enviada correctamente.</p>
                </Alert>
            )}

            {/* Popup de confirmación */}
            {comandaNoEnviada && (
                <Alert variant="danger" onClose={() => setComandaNoEnviada(false)} dismissible
                style={{
                    position: 'fixed', top: '10px', left: '50%', transform: 'translateX(-50%)', zIndex: 9999, width: 'auto'
                }}>
                    <Alert.Heading>¡Ocurrio un error!</Alert.Heading>
                    <p>{error}</p>
                </Alert>
            )}
        </div>
    );
}

export default Bodycompracafeteria;
